<template>
  <div class="count-page">
    <el-descriptions class="margin-top" :column="3">
      <el-descriptions-item label="出库单号">{{outBoundOrder.order_id}}</el-descriptions-item>
      <el-descriptions-item label="出库仓库">{{outBoundOrder.warehouse}}</el-descriptions-item>
      <el-descriptions-item label="出库单类型">{{outBoundOrder.order_type}}</el-descriptions-item>
      <el-descriptions-item label="品名">{{outBoundOrder.goods_name}}</el-descriptions-item>
      <el-descriptions-item label="指示箱数">{{outBoundOrder.pack_qty}}</el-descriptions-item>
      <el-descriptions-item label="物品总数">{{outBoundOrder.item_qty}}</el-descriptions-item>
      <el-descriptions-item label="责任人">{{outBoundOrder.charge_user_id}}</el-descriptions-item>
      <el-descriptions-item label="领取时间">{{outBoundOrder.take_time}}</el-descriptions-item>
    </el-descriptions>

    <div style="margin:10px;border 1px #e5e5e5">
      <el-row class="margin-top">
        <el-col :span="6">国家：{{outBoundOrder.user_info.country_cn}}</el-col>
        <el-col :span="6">省份：{{outBoundOrder.user_info.state}}</el-col>
        <el-col :span="6">市：{{outBoundOrder.user_info.city}}</el-col>
      </el-row>
      <el-row class="margin-top">
        <el-col :span="24">地址：{{outBoundOrder.user_info.address}}</el-col>
      </el-row>
      <el-row class="margin-top">
        <el-col :span="6">客户名称：{{outBoundOrder.user_info.customer_name}}</el-col>
        <el-col :span="6">收件人：{{outBoundOrder.user_info.name}}</el-col>
        <el-col :span="6">电话：{{outBoundOrder.user_info.phone}}</el-col>
        <el-col :span="6">邮件：{{outBoundOrder.user_info.email}}</el-col>
      </el-row>
    </div>

    <h2 style="width: 100%;text-align: center">快递面单明细</h2>
    <el-table :data="waybills" style="width: 100%" stripe @selection-change="selectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="way_bill_no" label="运单号"></el-table-column>
      <el-table-column prop="is_main" label="是否主运单号"></el-table-column>
      <el-table-column prop="seq_no" align="center" label="面单序号"></el-table-column>
    </el-table>
    <div style="width: 100%;text-align: center;margin: 20px 0">
      <el-button :loading="loading.reloadPdfsBtn" type="warning" @click="reloadPdfs">重新获取面单文件</el-button>
      <el-button :loading="loading.printWaybillsBtn" type="success" @click="printWaybills">打印选中</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "WayBillNoRecord",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: {
        reloadPdfsBtn: false,
        printWaybillsBtn: false
      },
      outBoundOrder: {},
      waybills:[],
      waybillIds:[]
    }
  },
  async created() {
    this.outBoundOrder = this.parentData
    this.getOrderWaybills()
  },
  methods: {
    selectionChange(val){
      this.waybillIds = []
      for (let i = 0; i < val.length; i++){
        this.waybillIds.push(val[i].id)
      }
    },
    reloadPdfs(){
      this.loading.reloadPdfsBtn = true;
      this.$http('outBoundService.getOrderPrintWaybills', {id: this.parentData.id, waybill_ids: this.waybillIds}, false).then(data => {
        this.loading.reloadPdfsBtn = false;
        this.$message.success("面单重新生成成功");
        this.getOrderWaybills();
      }, errMsg => {
        this.loading.reloadPdfsBtn = false;
        return this.$message.error(errMsg);
      })
    },
    async printWaybills() {
      if (this.waybillIds.length === 0) {
        this.$message.error('请选择要打印的快递面单')
        return
      }
      this.loading.printWaybillsBtn = true;
      this.$http('outBoundService.getPrintWaybillsPdfUrl', {order_id: this.parentData.id, waybill_ids: this.waybillIds}, false).then(data => {
        this.loading.printWaybillsBtn = false;
        // 创建隐藏的iframe
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = data;

        document.body.appendChild(iframe);

        iframe.onload = function () {
          iframe.contentWindow.print();
        };
      }, errMsg => {
        this.loading.printWaybillsBtn = false;
        return this.$message.error(errMsg);
      })
    },
    //获取快递面单明细
    async getOrderWaybills() {
      let data = await this.$http('outBoundService.getOrderWaybills', {order_id: this.parentData.id,});
      this.waybills = data;
    }
  }
}
</script>

<style scoped lang="less">
.count-page{
  margin: 10px;
}
</style>